import { render, staticRenderFns } from "./merchantdata.vue?vue&type=template&id=89a365c6&scoped=true"
import script from "./merchantdata.vue?vue&type=script&lang=js"
export * from "./merchantdata.vue?vue&type=script&lang=js"
import style0 from "./merchantdata.vue?vue&type=style&index=0&id=89a365c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a365c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a365c6')) {
      api.createRecord('89a365c6', component.options)
    } else {
      api.reload('89a365c6', component.options)
    }
    module.hot.accept("./merchantdata.vue?vue&type=template&id=89a365c6&scoped=true", function () {
      api.rerender('89a365c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/merchantdata.vue"
export default component.exports